import { gql } from '@apollo/client'

export const CHANGE_USER_PASSWORD = gql`
  mutation ChangePassword($inputData: ChangePasswordInput!) {
    changePassword(inputData: $inputData)
  }
`
